import { render, staticRenderFns } from "./GeneralControls.vue?vue&type=template&id=39e45fdd&scoped=true&"
import script from "./GeneralControls.vue?vue&type=script&lang=js&"
export * from "./GeneralControls.vue?vue&type=script&lang=js&"
import style0 from "./GeneralControls.vue?vue&type=style&index=0&id=39e45fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e45fdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VList,VListTile,VListTileTitle,VMenu,VTooltip})
